import Position from './Position';

/**
 * Describes the attributes of a Waypoint
 * Waypoints are used to traverse the Routing graph
 * 
 * @export {Waypoint}
 * @class Waypoint
 */
export default class Waypoint {
    constructor (id, location, x, y, z, map) {
        this._id = id;
        this._location = location;
        this._position = new Position(x, y, z);
        // Map is the LLN parsed for the first to sections ([Structure].[Map])
        const splitLocation = location.split('.');
        this._map = splitLocation[0] + '.' + splitLocation[1];
    }

    get id() {
        return this._id;
    }

    get location() {
        return this._location;
    }

    get position() {
        return this._position;
    }

    get map() {
        return this._map;
    }

    set id(id) {
        this._id = id;
    }

    set location(location) {
        this._location = location;
    }

    set position(position) {
        this._position = position;
    }
}


// WEBPACK FOOTER //
// ./src/classes/Waypoint.js